import React from 'react';

const POS = {
  top:    { bottom: '100%', left: '50%', transform: 'translateX(-50%)', mb: 8 },
  bottom: { top: '100%', left: '50%', transform: 'translateX(-50%)', mt: 8 },
  left:   { right: '100%', top: '50%', transform: 'translateY(-50%)', mr: 8 },
  right:  { left: '100%', top: '50%', transform: 'translateY(-50%)', ml: 8 },
};

/** Hover tooltip with a dark bubble. Wraps its trigger children. */
export function Tooltip({ label, placement = 'top', children, defaultOpen = false, style }) {
  const [open, setOpen] = React.useState(defaultOpen);
  const p = POS[placement] || POS.top;
  return (
    <span
      style={{ position: 'relative', display: 'inline-flex' }}
      onMouseEnter={() => setOpen(true)}
      onMouseLeave={() => setOpen(false)}
    >
      {children}
      {open && (
        <span
          role="tooltip"
          style={{
            position: 'absolute',
            zIndex: 10,
            top: p.top, bottom: p.bottom, left: p.left, right: p.right,
            transform: p.transform,
            marginTop: p.mt, marginBottom: p.mb, marginLeft: p.ml, marginRight: p.mr,
            padding: '6px 10px',
            borderRadius: 'var(--radius-sm)',
            background: 'var(--inverse-background)',
            color: 'var(--inverse-label)',
            fontFamily: 'var(--font-sans)',
            fontSize: 'var(--font-size-label-2)',
            lineHeight: 'var(--line-height-label-2)',
            fontWeight: 500,
            whiteSpace: 'nowrap',
            boxShadow: 'var(--shadow-strong)',
            pointerEvents: 'none',
            ...style,
          }}
        >
          {label}
        </span>
      )}
    </span>
  );
}

export default Tooltip;
